import { useRef } from 'react'
import { useResizeObserver } from 'usehooks-ts'

import { defaultCamera } from '@frame-builder/lib/frame-viewer/camera'
import { type GalleryCarousel3dPreviewItem } from '@lib/gallery'

import FrameViewer from '@frame-builder/components/frame-viewer'

interface GalleryCarouselSlide3dPreviewProps {
  index: number
  item: GalleryCarousel3dPreviewItem
  onClick?: (index: number) => void
}

const GalleryCarouselSlide3dPreview = ({
  index,
  item,
  onClick,
}: GalleryCarouselSlide3dPreviewProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const wrapperRectangle = useResizeObserver({
    ref: wrapperRef,
  })

  return (
    <div
      ref={wrapperRef}
      onClick={() => {
        if (onClick) {
          onClick(index)
        }
      }}
      className="carousel-slide"
    >
      {!!wrapperRectangle.width && (
        <FrameViewer
          frameSettings={item.frameSettings}
          camera={defaultCamera}
          width={wrapperRectangle.width}
          height={wrapperRectangle.width}
          backgroundColor={item.frameSettings.backgroundColor}
        />
      )}
    </div>
  )
}

export default GalleryCarouselSlide3dPreview
